/* eslint-disable */
import { lazy } from "react";
import { ADMIN_PATH, USER_SETTINGS_PATH } from "constants.js";
import { DEFAULT_PATHS } from "config.js";

import Portfolio from "views/pages/portfolio";
//const Batch = lazy(() => import("views/administration/academic-configs/batch"));

const publicPages = {
  eventAndInternships: {
    home: lazy(() =>import("views/pages/learning-opportunities/index-public")),
    internshipDetails: lazy(() =>import("views/pages/learning-opportunities/internships/browse")),
    eventDetails: lazy(() =>import("views/pages/learning-opportunities/events/browse")),
    trainingDetails: lazy(() =>import("views/pages/learning-opportunities/trainings/browse"))
  }
}

const dashboards = {
  class: lazy(() =>import("views/scrap/dashboards/ClassDashboard"))
}

const administration = {
  accessManagement: {
    home: lazy(() =>
      import("views/administration/access-management/AccessManagement")
    ),
  },
  academicConfigurations: {
    home: lazy(() =>
      import("views/administration/academic-configs/AcademicConfigurations")
    ),
    manageUniversities: lazy(() =>
      import("views/administration/academic-configs/ManageUniversities")
    ),
    manageInstitutes: lazy(() =>
      import("views/administration/academic-configs/ManageInstitutes")
    ),
    batch: lazy(() => import("views/administration/academic-configs/batch")),
    applicant: lazy(() =>
      import("views/administration/academic-configs/applicant")
    ),
    opening: lazy(() =>
      import("views/administration/academic-configs/opening")
    ),
    terms: lazy(() => import("views/administration/academic-configs/Terms")),
    terms_subject: lazy(() =>
      import("views/administration/academic-configs/terms-subject")
    ),
  },
  academics: {
    home: lazy(() => import("views/administration/academics")),
    batch: lazy(() => import("views/administration/academics/batch")),
    classrooms: lazy(() => import("views/administration/academics/classroom")),
    terms: lazy(() => import("views/administration/academics/terms")),
    termSubjects: lazy(() =>
      import("views/administration/academics/term-subjects")
    ),
  },
  community: {
    home: lazy(() => import("views/administration/community")),
    applicant: lazy(() => import("views/administration/community/applicant")),
    opening: lazy(() => import("views/administration/community/openings")),
  },
  core: {
    home: lazy(() => import("views/administration/core")),
    universities: lazy(() => import("views/administration/core/universities")),
    graduationLevels: lazy(() =>
      import("views/administration/core/graduation-levels")
    ),
    branches: lazy(() => import("views/administration/core/branches")),
    courses: lazy(() => import("views/administration/core/courses")),
    institutes: lazy(() => import("views/administration/core/institutes")),
    term_types: lazy(() => import("views/administration/core/term-types")),
    subject_types: lazy(() =>
      import("views/administration/core/subject-types")
    ),
    university_categories: lazy(() =>
      import("views/administration/core/university-categories")
    ),
    subjects: lazy(() => import("views/administration/core/subjects")),
  },
  events: {
    home: lazy(() => import("views/administration/events")),
    add: lazy(() => import("views/administration/events/add")),
    edit: lazy(() => import("views/administration/events/edit")),
    list: lazy(() => import("views/administration/events/list")),
    leads: lazy(() => import("views/administration/events/view/leads")),
    live: lazy(() => import("views/administration/events/view/live")),
    draft: lazy(() => import("views/administration/events/view/drafts")),
    concluded: lazy(() => import("views/administration/events/view/concluded")),
    manage: lazy(() => import("views/administration/events/manage")),
  },
  trainings: {
    home: lazy(() => import("views/administration/trainings")),
    add: lazy(() => import("views/administration/trainings/training/add")),
    edit: lazy(() => import("views/administration/trainings/training/edit")),
    list: lazy(() => import("views/administration/trainings/training/list")),
    manage: lazy(() => import("views/administration/trainings/training/manage")),
  },
  trainingBatches: {
    add: lazy(() => import("views/administration/trainings/batch/add")),
    edit: lazy(() => import("views/administration/trainings/batch/edit")),
    live: lazy(() => import("views/administration/trainings/batch/view/live")),
    draft: lazy(() => import("views/administration/trainings/batch/view/drafts")),
    concluded: lazy(() => import("views/administration/trainings/batch/view/concluded")),
    manage: lazy(() => import("views/administration/trainings/batch/manage")),
  },
};

// const apps = {
//   index: lazy(() => import("views/apps/Apps")),
//   chat: lazy(() => import("views/apps/chat/Chat")),
//   contacts: lazy(() => import("views/apps/contacts/Contacts")),
//   mailbox: lazy(() => import("views/apps/mailbox/Mailbox")),
//   tasks: lazy(() => import("views/apps/tasks/Tasks")),
// };

const pages = {
  /*
  index: lazy(() => import("views/pages/Pages")),
  signin: lazy(() => import("views/pages/signin/Signin")),
  calendar: lazy(() => import("views/scrap/pages/calendar/Calendar")),
  authentication: {
    index: lazy(() => import("views/scrap/pages/authentication/Authentication")),
    login: lazy(() => import("views/scrap/pages/authentication/Login")),
    register: lazy(() => import("views/scrap/pages/authentication/Register")),
    forgotPassword: lazy(() =>
      import("views/scrap/pages/authentication/ForgotPassword")
    ),
    resetPassword: lazy(() =>
      import("views/scrap/pages/authentication/ResetPassword")
    ),
  },
  */
  portfolio: {
    home: Portfolio,
  },
  settings: {
    home: lazy(() => import("views/pages/settings")),
    profile: lazy(() => import("views/pages/settings/profile")),
    academics: lazy(() => import("views/pages/settings/academics")),
    projects: lazy(() => import("views/pages/settings/projects")),
    trainings: lazy(() => import("views/pages/settings/trainings")),
    certifications: lazy(() => import("views/pages/settings/certifications")),
    workex: lazy(() => import("views/pages/settings/workex")),
  },
  learningOpportunities: {
    home: lazy(() => import("views/pages/learning-opportunities/")),
    internships: lazy(() => import("views/pages/learning-opportunities/internships/index")),
    trainings: lazy(() => import("views/pages/learning-opportunities/trainings/index")),
    events: lazy(() => import("views/pages/learning-opportunities/events/index"))
  }
};


const courses = {
  explore: lazy(() => import("views/scrap/courses/CoursesExplore")),
  list: lazy(() => import("views/scrap/courses/CoursesList")),
  detail: lazy(() => import("views/scrap/courses/CoursesDetail")),
};
const quiz = {
  list: lazy(() => import("views/scrap/quiz/QuizList")),
  detail: lazy(() => import("views/scrap/quiz/QuizDetail")),
  result: lazy(() => import("views/scrap/quiz/QuizResult")),
};

const paths = {
  list: lazy(() => import("views/scrap/paths/PathsList")),
  detail: lazy(() => import("views/scrap/paths/PathsDetail")),
};
/*
const instructor = {
  list: lazy(() => import("views/instructor/InstructorList")),
  detail: lazy(() => import("views/instructor/InstructorDetail")),
};

const misc = {
  player: lazy(() => import("views/misc/Player")),
  material: lazy(() => import("views/misc/Material")),
  syllabus: lazy(() => import("views/misc/Syllabus")),
};
*/

const appRoot = DEFAULT_PATHS.APP.endsWith("/")? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length): DEFAULT_PATHS.APP;
const routesAndMenuItems = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/portfolio`,
    },
    {
      path: `${appRoot}/portfolio`,
      icon: "diploma",
      label: "menu.portfolio",
      exact: true,
      roles: ["sudo", "std"],
      component: pages.portfolio.home,
    },
    {
      path: `${appRoot}/learning-opportunities`,
      icon: "calendar",
      label: "menu.internship-events",
      exact: true,
      roles: ["sudo","std"],
      component: publicPages.eventAndInternships.home,
      //component: pages.learningOpportunities.home,
    },
    {
      path: `${appRoot}/internships`,
      exact: true,
      redirect: true,
      to: `${appRoot}/learning-opportunities`,
    },
    {
      path: `${appRoot}/internships/:id`,
      icon: "calendar",
      label: "Internships",
      exact: true,
      roles: ["sudo","std"],
      component: pages.learningOpportunities.internships,
      hideInMenu:true
    },
    {
      path: `${appRoot}/events`,
      exact: true,
      redirect: true,
      to: `${appRoot}/learning-opportunities`,
    },
    {
      path: `${appRoot}/events/:id`,
      icon: "calendar",
      label: "Events",
      exact: true,
      roles: ["sudo","std"],
      component: pages.learningOpportunities.events,
      hideInMenu: true
    },
    {
      path: `${appRoot}/trainings`,
      exact: true,
      redirect: true,
      to: `${appRoot}/learning-opportunities`,
    },
    {
      path: `${appRoot}/trainings/:id`,
      icon: "calendar",
      label: "Trainings",
      exact: true,
      roles: ["sudo","std"],
      component: pages.learningOpportunities.trainings,
      hideInMenu:true
    },
    {
      path: `${appRoot}/settings`,
      label: "menu.settings",
      icon: "settings-1",
      exact: true,
      roles: ["sudo", "std"],
      to: `${appRoot}${USER_SETTINGS_PATH.HOME}`,
      component: pages.settings.home,
      subs: [
        {
          path: `${USER_SETTINGS_PATH.PROFILE}`,
          label: "menu.profile",
          component: pages.settings.profile,
          roles: ["sudo", "std"],
          to: `${appRoot}${USER_SETTINGS_PATH.HOME}${USER_SETTINGS_PATH.PROFILE}`,
          hideInMenu: true,
        },
        {
          path: `${USER_SETTINGS_PATH.ACADEMICS}`,
          label: "menu.academics",
          component: pages.settings.academics,
          roles: ["sudo", "std"],
          to: `${appRoot}${USER_SETTINGS_PATH.HOME}${USER_SETTINGS_PATH.ACADEMICS}`,
          hideInMenu: true,
        },
        {
          path: `${USER_SETTINGS_PATH.PROJECTS}`,
          label: "menu.projects",
          component: pages.settings.projects,
          roles: ["sudo", "std"],
          to: `${appRoot}${USER_SETTINGS_PATH.HOME}${USER_SETTINGS_PATH.PROJECTS}`,
          hideInMenu: true,
        },
        {
          path: `${USER_SETTINGS_PATH.TRAININGS}`,
          label: "menu.trainings",
          component: pages.settings.trainings,
          roles: ["sudo", "std"],
          to: `${appRoot}${USER_SETTINGS_PATH.HOME}${USER_SETTINGS_PATH.TRAININGS}`,
          hideInMenu: true,
        },
        {
          path: `${USER_SETTINGS_PATH.CERTIFICATIONS}`,
          label: "menu.certifications",
          component: pages.settings.certifications,
          roles: ["sudo", "std"],
          to: `${appRoot}${USER_SETTINGS_PATH.HOME}${USER_SETTINGS_PATH.CERTIFICATIONS}`,
          hideInMenu: true,
        },
        {
          path: `${USER_SETTINGS_PATH.WORKEX}`,
          label: "menu.workex",
          component: pages.settings.workex,
          roles: ["sudo", "std"],
          to: `${appRoot}${USER_SETTINGS_PATH.HOME}${USER_SETTINGS_PATH.WORKEX}`,
          hideInMenu: true,
        },
        /*
        {
          path: "/privacy",
          label: "menu.security-privacy",
          component: pages.profile.settings,
          hideInMenu: true,
        },
        */
      ],
    },
    
    {
      path: `${appRoot}${ADMIN_PATH.HOME}`,
      label: "menu.administration",
      icon: "tool",
      exact: true,
      redirect: true,
      roles: ["sudo"],
      subs: [
        {
          path: `${ADMIN_PATH.ACADEMIC_CONFIGURATION_OLD}`,
          label: "menu.academics",
          hideInMenu: true,
          component: administration.academicConfigurations.home,
          to: `${appRoot}${ADMIN_PATH.HOME}${ADMIN_PATH.ACADEMIC_CONFIGURATION_OLD}`,
        },
        {
          path: `${ADMIN_PATH.ACADEMIC_CONFIGURATION}`,
          label: "menu.academics",
          component: administration.academics.home,
          to: `${appRoot}${ADMIN_PATH.HOME}${ADMIN_PATH.ACADEMIC_CONFIGURATION}`,
          subs: [
            {
              path: `${ADMIN_PATH.ACADEMIC_BATCH}`,
              label: "Batch",
              component: administration.academics.batch,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.ACADEMIC_CLASSROOMS}`,
              label: "Classrooms",
              component: administration.academics.classrooms,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.ACADEMIC_TERMS}`,
              label: "Terms",
              component: administration.academics.terms,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.ACADEMIC_TERMSUBJECTS}`,
              label: "Term-Subjects",
              component: administration.academics.termSubjects,
              hideInMenu: true,
            },
          ],
        },
        {
          path: `${ADMIN_PATH.CLASSROOM_CONFIGURATION}`,
          label: "menu.classroom-config",
          component: administration.academicConfigurations.home,
        },
        {
          path: `${ADMIN_PATH.CORE_CONFIGURATION}`,
          label: "menu.core",
          component: administration.core.home,
          to: `${appRoot}${ADMIN_PATH.HOME}${ADMIN_PATH.CORE_CONFIGURATION}`,
          subs: [
            {
              path: `${ADMIN_PATH.CORE_UNIVERSITIES}`,
              label: "menu.universities",
              component: administration.core.universities,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.CORE_GRADUATION_LEVELS}`,
              label: "menu.graduation-levels",
              component: administration.core.graduationLevels,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.CORE_BRANCHES}`,
              label: "menu.branch",
              component: administration.core.branches,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.CORE_COURSES}`,
              label: "menu.courses",
              component: administration.core.courses,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.CORE_INSTITUTES}`,
              label: "menu.institutes",
              component: administration.core.institutes,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.CORE_TERM_TYPES}`,
              label: "menu.term-type",
              component: administration.core.term_types,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.CORE_SUBJECT_TYPES}`,
              label: "menu.subject",
              component: administration.core.subject_types,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.CORE_UNIVERSITY_CATEGORIES}`,
              label: "menu.university-categories",
              component: administration.core.university_categories,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.CORE_SUBJECTS}`,
              label: "menu.subjects",
              component: administration.core.subjects,
              hideInMenu: true,
            },
          ],
        },
        {
          path: `${ADMIN_PATH.COMMUNITY_CONFIGURATION}`,
          label: "menu.community",
          component: administration.community.home,
          subs: [
            {
              path: `${ADMIN_PATH.COMMUNITY_OPENINGS}`,
              label: "menu.openings",
              component: administration.community.opening,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.COMMUNITY_APPLICANTS}`,
              label: "menu.applicants",
              component: administration.community.applicant,
              hideInMenu: true,
            },
          ],
        },
        {
          path: `${ADMIN_PATH.ACCESS_MANAGEMENT}`,
          label: "menu.access-management",
          component: administration.accessManagement.home,
        },
        {
          path: `${ADMIN_PATH.UNIVERSITIES}`,
          label: "University Management",
          component: administration.academicConfigurations.manageUniversities,
          hideInMenu: true,
        },
        {
          path: `${ADMIN_PATH.INSTITUTES}`,
          label: "Institutes Management",
          component: administration.academicConfigurations.manageInstitutes,
          hideInMenu: true,
        },
        {
          path: `${ADMIN_PATH.MANAGE_BATCH}`,
          label: "Manage Batch",
          component: administration.academicConfigurations.batch,
          hideInMenu: true,
        },
        {
          path: `${ADMIN_PATH.MANAGE_APPLICANT}`,
          label: "Manage Applicant",
          component: administration.academicConfigurations.applicant,
          hideInMenu: true,
        },
        {
          path: `${ADMIN_PATH.MANAGE_OPENING}`,
          label: "Manage Opening",
          component: administration.academicConfigurations.opening,
          hideInMenu: true,
        },
        {
          path: `${ADMIN_PATH.TERMS}`,
          label: "Manage Terms",
          component: administration.academicConfigurations.terms,
          hideInMenu: true,
        },
        {
          path: `${ADMIN_PATH.TERM_SUBJECT}`,
          label: "Terms Subject",
          component: administration.academicConfigurations.terms_subject,
          hideInMenu: true,
        },
        {
          path: `${ADMIN_PATH.EVENT_CONFIGURATION}`,
          label: "menu.administraion.events",
          component: administration.events.home,
          to: `${appRoot}${ADMIN_PATH.HOME}${ADMIN_PATH.EVENT_CONFIGURATION}`,
          subs: [
            {
              path: `${ADMIN_PATH.EVENT_ADD}`,
              label: "menu.administraion.events.add",
              component: administration.events.add,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.EVENT_EDIT}/:id`,
              label: "menu.administraion.events.edit",
              component: administration.events.edit,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.EVENT_LIVE}`,
              label: "menu.administraion.events.live",
              component: administration.events.live,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.EVENT_DRAFTS}`,
              label: "menu.administraion.events.draft",
              component: administration.events.draft,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.EVENT_LEADS}`,
              label: "menu.administraion.events.leads",
              component: administration.events.leads,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.EVENT_CONCLUDED}`,
              label: "menu.administraion.events.concluded",
              component: administration.events.concluded,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.EVENT_LIST}`,
              label: "menu.administraion.events.list",
              component: administration.events.list,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.EVENT_MANAGE}/:id`,
              label: "Manage Events",
              component: administration.events.manage,
              hideInMenu: true,
            }
          ],
        },
        {
          path: `${ADMIN_PATH.TRAINING_CONFIGURATION}`,
          label: "menu.administraion.trainings",
          component: administration.trainings.home,
          to: `${appRoot}${ADMIN_PATH.HOME}${ADMIN_PATH.TRAINING_CONFIGURATION}`,
          subs: [
            {
              path: `${ADMIN_PATH.TRAINING_ADD}`,
              label: "menu.administraion.trainings.add",
              component: administration.trainings.add,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.TRAINING_LIST}`,
              label: "menu.administraion.trainings.list",
              component: administration.trainings.list,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.TRAINING_MANAGE}/:id`,
              label: "menu.administraion.trainings.manage",
              component: administration.trainings.manage,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.TRAINING_EDIT}/:id`,
              label: "menu.administraion.trainings.edit",
              component: administration.trainings.edit,
              hideInMenu: true,
            },
            {
              path: `${ADMIN_PATH.TRAINING_BATCH_CONFIGURATION}${ADMIN_PATH.TRAINING_BATCH_ADD}`,
              label: "menu.administraion.training.batch.add",
              component: administration.trainingBatches.add,
              hideInMenu: true,
              exact: true
            },
            {
              path: `${ADMIN_PATH.TRAINING_BATCH_CONFIGURATION}${ADMIN_PATH.TRAINING_BATCH_EDIT}/:id`,
              label: "menu.administraion.training.batch.edit",
              component: administration.trainingBatches.edit,
              hideInMenu: true,
              exact: true
            },
            {
              path:`${ADMIN_PATH.TRAINING_BATCH_CONFIGURATION}${ADMIN_PATH.TRAINING_BATCH_MANAGE}/:id`,
              label: "menu.administraion.training.batch.manage",
              component: administration.trainingBatches.manage,
              hideInMenu: true,
              exact: true
            },
            {
              path: `${ADMIN_PATH.TRAINING_BATCH_CONFIGURATION}${ADMIN_PATH.TRAINING_BATCH_LIVE}`,
              label: "menu.administraion.training.batch.live",
              component: administration.trainingBatches.live,
              hideInMenu: true,
              exact: true
            },
            {
              path: `${ADMIN_PATH.TRAINING_BATCH_CONFIGURATION}${ADMIN_PATH.TRAINING_BATCH_DRAFTS}`,
              label: "menu.administraion.training.batch.draft",
              component: administration.trainingBatches.draft,
              hideInMenu: true,
              exact: true
            },
            {
              path: `${ADMIN_PATH.TRAINING_BATCH_CONFIGURATION}${ADMIN_PATH.TRAINING_BATCH_CONCLUDED}`,
              label: "menu.administraion.training.batch.concluded",
              component: administration.trainingBatches.concluded,
              hideInMenu: true,
              exact: true
            },
            {
              path: `/:id`,
              label: "menu.administraion.trainings.view",
              component: pages.learningOpportunities.trainings,
              hideInMenu: true,
            }
          ],
        },
      ],
    },
    /*
    {
      path: `${appRoot}/classroom`,
      icon: "board-2",
      label: "menu.classroom",
      exact: true,
      roles: ["sudo", "std"],
      component: dashboards.class,
    },
    {
      path: `${appRoot}/courses`,
      label: 'menu.courses',
      icon: 'online-class',
      exact: true,
      redirect: true,
      to: `${appRoot}/courses/explore`,
      subs: [
        { path: '/explore', label: 'menu.explore', component: courses.explore },
        { path: '/list', label: 'menu.list', component: courses.list },
        { path: '/detail', label: 'menu.detail', component: courses.detail },
      ],
    },
    {
      path: `${appRoot}/quiz`,
      label: 'menu.quiz',
      icon: 'quiz',
      exact: true,
      redirect: true,
      to: `${appRoot}/quiz/list`,
      subs: [
        { path: '/list', label: 'menu.list', component: quiz.list },
        { path: '/detail', label: 'menu.detail', component: quiz.detail },
        { path: '/result', label: 'menu.result', component: quiz.result },
      ],
    },
    {
      path: `${appRoot}/paths`,
      label: 'Learning Path',
      icon: 'destination',
      exact: true,
      redirect: true,
      to: `${appRoot}/paths/list`,
      roles: ["sudo", "std"],
      subs: [
        { path: '/list', label: 'menu.list', component: paths.list },
        { path: '/detail', label: 'menu.detail', component: paths.detail },
        { path: `${appRoot}/courses/details`, label: 'Course Details', component: courses.detail },
      ],
    },
    */
   /*
    {
      path: `${appRoot}/calendar`,
      icon: "calendar",
      label: "menu.calendar-and-events",
      exact: true,
      roles: ["sudo", "std"],
      component: pages.calendar,
    },
    */
    /*
    {
      path: `${appRoot}/tasks`,
      icon: "check-square",
      label: "menu.task-bucket",
      exact: true,
      roles: ["sudo", "std"],
      component: dashboards.class,
    },
    {
      path: `${appRoot}/dashboard`,
      icon: "grid-5",
      label: "menu.dashboard",
      exact: true,
      protected: true,
      roles: ["std"],
      component: dashboards.elearning,
    },
    {
      path: `${appRoot}/applicant`,
      icon: "check-square",
      label: "Task Bucket",
      exact: true,
      hideInMenu: true,
      component: pages.applicant,
    },
    {
      path: `${appRoot}/batch`,
      icon: "online-class",
      label: "menu.batch",
      exact: true,
      hideInMenu: true,
      protected: true,
      roles: ["sudo"],
      component: Batch,
    },
    {
      path: `${appRoot}/instructor`,
      label: 'menu.instructor',
      icon: 'lecture',
      exact: true,
      redirect: true,
      to: `${appRoot}/instructor/list`,
      subs: [
        { path: '/list', label: 'menu.list', component: instructor.list },
        { path: '/detail', label: 'menu.detail', component: instructor.detail },
      ],
    },
    
    {
      path: `${appRoot}/misc`,
      label: 'menu.misc',
      icon: 'layout-5',
      exact: true,
      redirect: true,
      to: `${appRoot}/misc/player`,
      subs: [
        { path: '/player', label: 'menu.player', component: misc.player },
        { path: '/material', label: 'menu.material', component: misc.material },
        { path: '/syllabus', label: 'menu.syllabus', component: misc.syllabus },
      ],
    },
    {
      path: `${appRoot}/pages`,
      label: 'menu.pages',
      icon: 'notebook-1',
      component: pages.index,
      subs: [
        {
          path: '/authentication',
          label: 'menu.authentication',
          component: pages.authentication.index,
          subs: [
            { path: '/login', label: 'menu.login', component: pages.authentication.login, noLayout: true },
            { path: '/register', label: 'menu.register', component: pages.authentication.register, noLayout: true },
            { path: '/forgot-password', label: 'menu.forgot-password', component: pages.authentication.forgotPassword, noLayout: true },
            { path: '/reset-password', label: 'menu.reset-password', component: pages.authentication.resetPassword, noLayout: true },
          ],
        },
        {
          path: '/portfolio',
          label: 'menu.portfolio',
          component: pages.portfolio.index,
          subs: [
            { path: '/home', label: 'menu.home', component: pages.portfolio.home },
            { path: '/detail', label: 'menu.detail', component: pages.portfolio.detail },
          ],
        },
        {
          path: '/profile',
          label: 'menu.profile',
          component: pages.profile.index,
          subs: [
            { path: '/standard', label: 'menu.standard', component: pages.profile.standard },
            { path: '/settings', label: 'menu.settings', component: pages.profile.settings },
          ],
        },
      ],
    },
    {
      path: `${appRoot}/requests`,
      label: 'menu.approval-requests',
      icon: 'like',
      component: pages.index,
      subs: [
        {path: '/student-registration', label: 'menu.student-registration', component: pages.portfolio.index}
      ],
    },
    
    {
      path: `${appRoot}/pedagogy`,
      label: 'menu.pedagogy',
      icon: 'pen',
      component: pages.index,
      subs: [
        {path: '/sections', label: 'menu.sections', component: pages.portfolio.index},
        {path: '/classes', label: 'menu.classes', component: pages.portfolio.index},
        {path: '/timetable', label: 'menu.timetable', component: pages.portfolio.index},
        {path: '/syllabus', label: 'menu.syllabus', component: pages.portfolio.index}
      ],
    },
    {
      path: `${appRoot}/user-management`,
      label: 'menu.user-management',
      icon: 'user',
      component: pages.index,
      subs: [
        {path: '/community', label: 'menu.community', component: pages.portfolio.index},
        {path: '/students', label: 'menu.students', component: pages.portfolio.index},
        {path: '/teachers', label: 'menu.teachers', component: pages.portfolio.index},
      ],
    },
    {
      path: `${appRoot}/learning-management`,
      label: 'menu.academic-learning',
      icon: 'graduation',
      component: pages.index,
      subs: [
        {path: '/tasks', label: 'menu.learning-calendar', component: pages.portfolio.index},
        {path: '/events', label: 'menu.learning-events', component: pages.portfolio.index},
        {path: '/tasks', label: 'menu.learning-tasks', component: pages.portfolio.index},
      ],
    },
    {
      path: `${appRoot}/academic-structure`,
      label: 'menu.academic-structure',
      icon: 'settings-1',
      component: pages.index,
      subs: [
        {path: '/batch', label: 'menu.batch', component: pages.portfolio.index},
        {path: '/branch', label: 'menu.branch', component: pages.portfolio.index},
        {path: '/courses', label: 'menu.courses', component: pages.portfolio.index},
        {path: '/institutes', label: 'menu.institutes', component: pages.portfolio.index},
        {path: '/subjects', label: 'menu.subjects', component: pages.portfolio.index},
        {path: '/term', label: 'menu.term', component: pages.portfolio.index},
        {path: '/universities', label: 'menu.universities', component: pages.portfolio.index},
      ],
    },
    {
      path: `${appRoot}/access-management`,
      label: 'Access Management',
      icon: 'shield',
      component: pages.index,
      subs: [
        {path: '/batch', label: 'menu.batch', component: pages.portfolio.index},
        {path: '/branch', label: 'menu.branch', component: pages.portfolio.index},
        {path: '/courses', label: 'menu.courses', component: pages.portfolio.index},
        {path: '/institutes', label: 'menu.institutes', component: pages.portfolio.index},
        {path: '/subjects', label: 'menu.subjects', component: pages.portfolio.index},
        {path: '/term', label: 'menu.term', component: pages.portfolio.index},
        {path: '/universities', label: 'menu.universities', component: pages.portfolio.index},
      ],
    }
    */
  ],
  websiteMenuItems: [
    {
      path: `https://workabl.in/`,
      label: "What's Workabl?",
      exact: true,
      roles: ["public"],
      isExternal:true
    },
    {
      path: `${appRoot}/events-and-internships`,
      label: "menu.internship-events",
      exact: true,
      roles: ["public"],
      component: publicPages.eventAndInternships.home,
      noLayout: true
    },
    {
      path: `${appRoot}/internships/:id/browse`,
      label: "menu.internship-events",
      exact: true,
      roles: ["public"],
      component: publicPages.eventAndInternships.internshipDetails,
      hideInMenu:true,
      noLayout: true
    },
    {
      path: `${appRoot}/events/:id/browse`,
      label: "menu.internship-events",
      exact: true,
      roles: ["public"],
      component: publicPages.eventAndInternships.eventDetails,
      hideInMenu:true,
      noLayout: true
    },
    {
      path: `${appRoot}/trainings/:id/browse`,
      label: "menu.internship-events",
      exact: true,
      roles: ["public"],
      component: publicPages.eventAndInternships.trainingDetails,
      hideInMenu:true,
      noLayout: true
    },
    {
      path: `https://console.workabl.in/signin`,
      label: "SignIn / SignUp",
      exact: true,
      roles: ["public"],
      isExternal:true
    }
  ],
  sidebarItems: [],
};
export default routesAndMenuItems;